import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ProjectsContext } from '../../../providers/ProjectsProvider';
import type { AuthenticationConfig } from '../../../state-management/states';
import RoleAssignmentComponent from './Base';

const ProjectLevelAssignment: React.FC<{
    token: string;
    authConfig: AuthenticationConfig;
}> = ({
    token,
    authConfig,
}) => {
    const { state: projectState } = useContext(ProjectsContext);

    const currentProject = React.useMemo(() => projectState.currentProject, [ projectState ]);
    const state: any = useLocation()?.state;
    const userInfo = state.data.userInfo;

    return (
        <RoleAssignmentComponent
            level="PROJECT"
            token={token}
            projectId={currentProject?.id}
            projectName={currentProject?.name}
            userInfo={userInfo}
            identityUrl={authConfig.identityAPIUrl} />
    );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default connect((state: any) => ({
    token: state.auth.authToken,
    authConfig: state.config.paths ? state.config.paths.authConfig : {},
}))(ProjectLevelAssignment);
